import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const SkeletonLoader = () => {
  return (
    <div className="skeleton-container">
      {/* Hero Section Skeleton */}
      <div className="skeleton-hero">
        <Container>
          <Row className="justify-center">
            <Col xl={6} lg={7} md={8} className="text-center">
              <div className="skeleton-title mb-4"></div>
              <div className="skeleton-subtitle mb-3"></div>
              <div className="skeleton-text mb-5"></div>
              <div className="skeleton-button"></div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Content Sections Skeleton */}
      <div className="skeleton-section">
        <Container>
          <Row>
            <Col lg={6}>
              <div className="skeleton-image"></div>
            </Col>
            <Col lg={6} className="flex flex-col justify-center">
              <div className="skeleton-title mb-3"></div>
              <div className="skeleton-text mb-2"></div>
              <div className="skeleton-text mb-2"></div>
              <div className="skeleton-text mb-4"></div>
              <div className="skeleton-button"></div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Cards Section Skeleton */}
      <div className="skeleton-section">
        <Container>
          <Row>
            <Col md={4} className="mb-4">
              <div className="skeleton-card">
                <div className="skeleton-card-image"></div>
                <div className="skeleton-card-content">
                  <div className="skeleton-title mb-2"></div>
                  <div className="skeleton-text mb-2"></div>
                  <div className="skeleton-text"></div>
                </div>
              </div>
            </Col>
            <Col md={4} className="mb-4">
              <div className="skeleton-card">
                <div className="skeleton-card-image"></div>
                <div className="skeleton-card-content">
                  <div className="skeleton-title mb-2"></div>
                  <div className="skeleton-text mb-2"></div>
                  <div className="skeleton-text"></div>
                </div>
              </div>
            </Col>
            <Col md={4} className="mb-4">
              <div className="skeleton-card">
                <div className="skeleton-card-image"></div>
                <div className="skeleton-card-content">
                  <div className="skeleton-title mb-2"></div>
                  <div className="skeleton-text mb-2"></div>
                  <div className="skeleton-text"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <style jsx>{`
        .skeleton-container {
          min-height: 100vh;
          padding: 100px 0;
        }

        .skeleton-hero {
          height: 60vh;
          display: flex;
          align-items: center;
          margin-bottom: 80px;
        }

        .skeleton-section {
          padding: 60px 0;
        }

        .skeleton-title {
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-subtitle {
          height: 24px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          width: 80%;
          margin: 0 auto;
        }

        .skeleton-text {
          height: 16px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-button {
          height: 48px;
          width: 150px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 25px;
          margin: 0 auto;
        }

        .skeleton-image {
          height: 300px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 8px;
        }

        .skeleton-card {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .skeleton-card-image {
          height: 200px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
        }

        .skeleton-card-content {
          padding: 20px;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        @media (max-width: 768px) {
          .skeleton-hero {
            height: 50vh;
          }
          
          .skeleton-section {
            padding: 40px 0;
          }
          
          .skeleton-image {
            height: 200px;
            margin-bottom: 30px;
          }
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoader; 